import { useLocation } from 'react-router-dom';
import '../styles/header.css';
import getUrlLogo from '../utils/getUrlLogo';

const Header = () => {
  const location = useLocation();
  return (
    <header>
      <div className="colorBar" />
      <div className="headerContent">
        <div className="left" style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src={getUrlLogo(process.env.REACT_APP_COMPANY_NAME || '', "main_white_logo.png")}
            alt="Logo"
            style={{
              maxWidth: '360px',
              maxHeight: '100px',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
              paddingLeft: '40px',
              paddingRight: '40px'
            }}
          />
        </div>
        {/* <div className="right">
        <b>{location.pathname == "/info" ? "Información" : "Reserva de Horas"}</b>
      </div> */}
      </div>
    </header>
  );
};

export default Header;
